import { Form, Button, Col, Container, Row, Alert } from "react-bootstrap";
import "../css/contacts.css";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../services/auth";
import ApiService from "../../../services/api";
import env from '../../../env';
import { Link } from "react-router-dom";

const Contacts = () => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const [errors, setErrors] = useState(false);
	const [isTrue, setIsTrue] = useState(false);
	const { isEnglish } = useContext(AuthContext);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		description: "",
	});

	const [captchaID, setCaptchaID] = useState();
	const [captchaURL, setCaptchaURL] = useState();
	const [captchaValue, setCaptchaValue] = useState();
	const [validateCaptcha, setValidateCaptcha] = useState(false);
	const [isMailLoading, setIsMailLoading] = useState(false);
    const [isMailSent, setIsMailSent] = useState(false);

	const fetchCaptcha = async () => {
		try {
			let responseData = await ApiService.getCaptcha();
			setCaptchaID(responseData.captcha_id);
			setCaptchaURL(responseData.captcha_url);
		} catch (error) {
			console.error('Error fetching captcha:', error);
		}
	}

	useEffect(() => {
		fetchCaptcha();
	}, []);


	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === "checkbox" ? checked : value,
		});
	};

	const handleSubmit = async () => {

		if (
			!isTrue ||
			formData.name === "" ||
			formData.email === "" ||
			!emailRegex.test(formData.email) ||
			formData.description === ""
		) {
			setErrors(true);
			return;
		} else {
			setErrors(false);
		}
		if (captchaValue === '' || captchaValue === undefined) {
			setValidateCaptcha(true);
			return;
		} else {
			setValidateCaptcha(false);
		}

		setIsMailLoading(true);

		let finalFormData = {
			...formData,
			captcha_id: captchaID,
			captcha_value: captchaValue
		}

		try {
			let result = await ApiService.sendEmail(finalFormData);
			if(result.status === 200) {
				setIsMailSent(true);
				setIsMailLoading(false);
				setFormData({
					name: "",
					email: "",
					description: "",
				});
				setIsTrue(false);
				setCaptchaValue('');
				fetchCaptcha();
				window.scrollTo({
					top: document.querySelector('#contacts-container').offsetTop - 250,
					behavior: 'smooth',
				});
			}
		} catch(err) {
			setIsMailLoading(false);
	
			if (err.response && err.response.status === 400) {
				setValidateCaptcha(true);
			} else {
				console.error('Unexpected error:', err);
			}
		}
	};

	return (
		<Container fluid id="contacts-container" className="padding_custom mb-5 pb-5">
			<h3 className=" text-center pt-5 section-title mt-5">{isEnglish ? "CONTACTS" : "CONTATTI"}</h3>
			<div className="border-custom mt-3 mb-5"></div>
			<Container className="w-100 mt-5">
				
			{isMailSent && <>
				<Alert key="success" variant="success">
					<Container>
						<h4>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
								<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
								<path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
							</svg> 
							<strong>{isEnglish ? "Request sent" : "Richiesta inviata"}</strong>
						</h4>
					</Container>
					
					<Container>
						<Row>
							<Col lg="12">
								<p className="page-text-content mb-0">
									{isEnglish ? "The request has been sent successfully, you will be contacted soon." : "La richiesta è stata inviata con successo, sarai ricontattato presto."}
								</p>
							</Col>
						</Row>
					</Container>
				</Alert>				
			</>}			

				<Row className="d-flex justify-content-center">
					<Col lg={12} xl={10}>
						<Form className="p-5 color-container-contacts text_contacts">
							<Form.Group className="mb-3 " controlId="nameImput">
								<Form.Label>{isEnglish ? "Name" : "Nome"}</Form.Label>
								<Form.Control
									type="text"
									placeholder={isEnglish ? "Name" : "Nome"}
									value={formData.name}
									name="name"
									onChange={handleChange}
								/>
								{formData.name === "" && errors && (
									<span style={{ color: "red" }}>
										{isEnglish ? "Mandatory field" : "Campo obbligatorio"}
									</span>
								)}
							</Form.Group>

							<Form.Group className="mb-3 " controlId="emailImput">
								<Form.Label>Email</Form.Label>
								<Form.Control
									type="email"
									placeholder="Email"
									value={formData.email}
									name="email"
									onChange={handleChange}
								/>
								{(formData.email === "" && errors) && (
									<span style={{ color: "red" }}>
										{isEnglish
											? "Mandatory field"
											: "Campo obbligatorio"}
									</span>
								)}
								{(formData.email && !emailRegex.test(formData.email) && errors) && (
									<span style={{ color: "red" }}>
										{isEnglish
											? "Invalid email"
											: "Email non valida"}
									</span>
								)}
							</Form.Group>

							<Form.Group className="mb-3" controlId="textareaImput">
								<Form.Label>{isEnglish ? "Message" : "Messaggio"}</Form.Label>
								<Form.Control
									as="textarea"
									rows={3}
									placeholder={isEnglish ? "Description" : "Descrizione"}
									value={formData.description}
									name="description"
									onChange={handleChange}
								/>
								{formData.description === "" && errors && (
									<span style={{ color: "red" }}>
										{isEnglish ? "Mandatory field" : "Campo obbligatorio"}
									</span>
								)}
							</Form.Group>

							<Form.Group className="mt-4">
								<Form.Label>
									{isEnglish ? "Privacy Policy" : "Informativa Privacy"}
								</Form.Label>
								<Form.Check
									required
									label={isEnglish ? <span>I have read and understood the <Link to={"/privacy-policy"} rel="noreferrer" className="site-link">privacy policy</Link>.</span> : <span>Ho letto e compreso l'<a href="/privacy-policy" target="_blank" rel="noreferrer" className="site-link">informativa sulla privacy</a></span>}
									feedback="You must agree before submitting."
									feedbackType="invalid"
									className="ms-1"
									onChange={() => {
										isTrue ? setIsTrue(false) : setIsTrue(true);
									}}
									checked={isTrue}
								/>
								{!isTrue && (
									<span style={{ color: "red" }}>
										{!isTrue && errors
											? isEnglish
												? "Mandatory field"
												: "Campo obbligatorio"
											: ""}
									</span>
								)}
							</Form.Group>

							<Row className="mt-5 align-items-center">
								<Col md="6" lg="3">
									<div>
										{captchaURL && <img src={env.BACKEND_BASE_URL + captchaURL} alt="Captcha" style={{width: "100%", maxWidth: "100%"}} />}
									</div>
									<div className="mt-2">
										<button type="button" className="btn btn-sm btn-dark w-100" onClick={fetchCaptcha}>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
												<path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
												<path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
											</svg> 
											{isEnglish ? "Refresh Code" : "Rigenera Codice"}
										</button>
									</div>
								</Col>
								<Col md="6" lg="9">
									<label>{isEnglish ? "Enter the code you see:" : "Inserisci il codice che visualizzi:"} <input className="form-control" type="text" name="captcha" value={captchaValue} onChange={(e) => setCaptchaValue(e.target.value.toUpperCase())} /></label>
									{validateCaptcha && <p><small className="invalid-feedback-standalone form-text" style={{ color: "red" }}>Il codice inserito non è corretto.</small></p>} 
								</Col>
							</Row>


							<Form.Group
								className="mb-3 d-flex align-items-center justify-content-center mt-3"
								controlId="submit"
							>								
								<Button
									onClick={handleSubmit}
									className="text-center button-custom-contacts mt-5"
									variant=""
								>
									{isMailLoading ? (isEnglish ? "Sending..." : "Invio in corso...") : (isEnglish ? "Send" : "Invia")}
								</Button>
							</Form.Group>
						</Form>
					</Col>
					<Col
						className="color-container-contacts margin-custom-side d-flex align-items-center justify-content-center p-0"
						xs={{ order: "first" }}
						xl={{ order: "last" }}
					>
						<div className="">
							<h3 className="text-center">
								{" "}
								{isEnglish ? "Contacts" : "Contatti"}
							</h3>
							<p className="text-center mt-4 fs-5">E-mail</p>
							<a
								href="mailto:info@rosellaclementi.it "
								className="text-center d-flex align-items-center justify-content-center site-link"
							>
								info@rosellaclementi.it
							</a>
						</div>
					</Col>
				</Row>
			</Container>
		</Container>
	);
};
export default Contacts;
